module.exports = __webpack_public_path__ + "img/hyperagent.e9f0b7e5.png";